import React from 'react';
import { Outlet } from 'react-router-dom';
import ProcessBizDevDetail from './ProcessBizDevDetail';

const PositionDetailLayout = () => {
  return (
    <>
      {/* PositionDetail reste toujours monté */}
      <ProcessBizDevDetail />

      {/* Outlet pour les routes enfants (IndividualDetailPage) qui s'affichent par-dessus */}
      <Outlet />
    </>
  );
};

export default PositionDetailLayout;
